import { render, staticRenderFns } from "./ReflectionDetails.vue?vue&type=template&id=6a17781a&scoped=true&"
import script from "./ReflectionDetails.vue?vue&type=script&lang=js&"
export * from "./ReflectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionDetails.vue?vue&type=style&index=0&id=6a17781a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17781a",
  null
  
)

export default component.exports